const RETURN_TO_KEY = 'returnTo';
const DEFAULT_HOME = '/candidate/home';

/** Relative app paths only — no open redirects, no login/oauth loops. */
export function isSafeReturnPath(path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) {
    return false;
  }
  const pathname = path.split('?')[0];
  if (pathname === '/login' || pathname === '/oauth-callback' || pathname.startsWith('/oauth-callback')) {
    return false;
  }
  return true;
}

export function defaultHomeForRole(role) {
  if (!role || role === 'guest') return '/login';
  return DEFAULT_HOME;
}

export function canRoleAccessPath(role, path) {
  const pathname = String(path || '').split('?')[0];
  if (!role || role === 'guest') return false;
  if (
    pathname.startsWith('/admin') ||
    pathname.startsWith('/whatsapp') ||
    pathname.startsWith('/invoices') ||
    pathname === '/execedge-funnel' ||
    pathname === '/execedge-comms'
  ) {
    return role === 'admin';
  }
  if (pathname.startsWith('/execedge/dashboard')) {
    return role === 'admin' || role === 'recruiter' || role === 'guide';
  }
  return true;
}

/** After login, send the user somewhere their role can actually open. */
export function resolvePostLoginPath(requestedPath, role) {
  const home = defaultHomeForRole(role);
  if (!role || role === 'guest') return '/login';
  const requested = isSafeReturnPath(requestedPath) ? requestedPath : home;
  const pathname = requested.split('?')[0];
  if (pathname === '/' || pathname === '/login') return home;
  if (!canRoleAccessPath(role, requested)) return home;
  return requested;
}

export function saveReturnTo(path) {
  if (!isSafeReturnPath(path)) return false;
  localStorage.setItem(RETURN_TO_KEY, path);
  return true;
}

export function saveReturnToFromWindow() {
  if (typeof window === 'undefined') return false;
  return saveReturnTo(window.location.pathname + window.location.search);
}

export function getReturnTo(fallback = '/') {
  const stored = localStorage.getItem(RETURN_TO_KEY);
  if (isSafeReturnPath(stored)) return stored;
  if (isSafeReturnPath(fallback)) return fallback;
  return '/';
}

/** Read and clear stored returnTo, falling back to a hash/query next path. */
export function consumeReturnTo(fallback = '/') {
  const stored = localStorage.getItem(RETURN_TO_KEY);
  localStorage.removeItem(RETURN_TO_KEY);
  if (isSafeReturnPath(stored)) return stored;
  if (isSafeReturnPath(fallback)) return fallback;
  return '/';
}
